import { CategoryCard } from './CategoryCard.jsx';
import styles from './category_view.module.css';

const DEFAULT_ICON = 'fa-folder';

export const CategoryCardsGrid = ({
  categories,
  categoryCounts,
  onSelectCategory,
}) => {
  return (
    <div className={styles.cardsGrid}>
      {categories.map(category => (
        <CategoryCard
          key={category.value}
          icon={category.icon || DEFAULT_ICON}
          name={category.label}
          fileCount={categoryCounts[category.value] || 0}
          onClick={() => onSelectCategory(category)}
        />
      ))}
    </div>
  );
};
